import React from "react";

/**
 * @component ArrowRestoreIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowRestoreIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowRestoreIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="ArrowRestoreIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M17.026 19.796a9 9 0 01-12.294-3.294l-1.732 1 .653-4.87 4.543 1.87-1.732 1a7 7 0 102.562-9.563 6.944 6.944 0 00-3.248 4.254l-1.94-.52a8.896 8.896 0 014.188-5.466 9 9 0 019 15.589z"
        clipRule="evenodd"
      />
    </svg>
  )
);
ArrowRestoreIcon.displayName = "ArrowRestoreIcon";
export default ArrowRestoreIcon;
